import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuillService {

  constructor() { }

  public quillInstanceMap = new Map<string,any>()
  public selectionMap = new Map<string,any>()

  formatText(content, disableFormatting = false) {
    let whiteFormattingList = disableFormatting ? [] : ['list', 'italic', 'bold', 'underline', 'link', 'image', 'style'];

        let filteredContent = content.map((elem)=>{      
            // Return image as it is
            if (elem.insert && typeof elem.insert === 'object' && elem.insert.image) {
                return elem; 
            }

            if(elem.attributes){
                let attrArr = Object.keys(elem.attributes)

                attrArr.forEach((attr)=>{
                    let included = whiteFormattingList.includes(attr)
                    if(!included){
                        delete elem.attributes[attr]
                    }
                })
                return elem
            }

            if( typeof elem.insert == "string"){
                return elem
            }
        })

        return filteredContent.filter((elem)=>elem !== undefined )
  }
}
